import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, AlertTriangle } from 'lucide-react';
export function ExitIntentPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    if (hasShown) return;
    const handleMouseLeave = (e: MouseEvent) => {
      // Trigger when cursor moves above the viewport
      if (e.clientY <= 0 && !hasShown) {
        setIsOpen(true);
        setHasShown(true);
      }
    };
    // Mobile fallback: trigger on rapid scroll up near the top or after a delay if user becomes idle
    let mobileTimer: ReturnType<typeof setTimeout> | null = null;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
      // Show after 30 seconds of idleness as a soft fallback on mobile
      mobileTimer = setTimeout(() => {
        if (!hasShown) {
          setIsOpen(true);
          setHasShown(true);
        }
      }, 30000);
    }
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      if (mobileTimer) clearTimeout(mobileTimer);
    };
  }, [hasShown]);
  const handleClose = () => setIsOpen(false);
  return <AnimatePresence data-id="element-16">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={handleClose} className="fixed inset-0 bg-black/70 z-[200] backdrop-blur-sm" data-id="element-17" />
          <div className="fixed inset-0 z-[201] flex items-center justify-center p-4 pointer-events-none" data-id="element-18">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 25
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-md pointer-events-auto relative overflow-hidden" data-id="element-19">
              {/* Top accent bar */}
              <div className="h-2 bg-gradient-to-r from-red-500 via-orange-500 to-red-500" data-id="element-20" />

              {/* Close button */}
              <button onClick={handleClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors z-10" aria-label="Close popup" data-id="element-21">
                <X className="w-5 h-5" data-id="element-22" />
              </button>

              <div className="p-6 sm:p-8 text-center" data-id="element-23">
                {/* Warning icon */}
                <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-24">
                  <AlertTriangle className="w-8 h-8 text-red-600" data-id="element-25" />
                </div>

                <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-26">
                  Wait! Don't Leave Yet
                </h2>

                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-2" data-id="element-27">
                  You're about to miss out on over
                </p>
                <p className="text-4xl sm:text-5xl font-extrabold text-red-600 mb-2" data-id="element-28">
                  $14,000
                </p>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6" data-id="element-29">
                  in savings on a complete bathroom remodel.
                </p>

                <div className="flex flex-col gap-3" data-id="element-30">
                  <a href="https://skro.dailyhomewellness.com/click" className="w-full py-4 bg-green-600 hover:bg-green-700 text-white text-lg sm:text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 text-center inline-block" data-id="element-31">
                    YES, CLAIM MY SAVINGS
                  </a>
                  <button onClick={handleClose} className="w-full py-2 text-sm text-gray-500 hover:text-gray-700 underline underline-offset-4 transition-colors" data-id="element-32">
                    No thanks, I'll pay full price
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}